<clr-tabs>
  <clr-tab>
    <button clrTabLink>Export report</button>
    <clr-tab-content>
      <form clrForm>
        <clr-select-container>
          <label>Billing period</label>
          <select clrSelect name="billingperiodsselect" [(ngModel)]="selectedBillingPeriod"
            (ngModelChange)="selectedBillingPeriodChange()">
            <option [ngValue]="BmsBillingPeriod.Month"> Month</option>
            <option [ngValue]="BmsBillingPeriod.Quarter"> Quarter</option>
            <option [ngValue]="BmsBillingPeriod.SixMonths"> Six months</option>
          </select>
        </clr-select-container>
        <clr-select-container>
          <label>Export period</label>
          <select clrSelect name="exportperiodsselect" [(ngModel)]="selectedExportPeriod"
            (ngModelChange)="selectedExportPeriodChange()">
            <option *ngFor="let period of exportPeriods; let i = index" [ngValue]="i">
              {{formatByString(period.start,
              'yyyy-MM-dd') + ' - ' + formatByString(period.end, 'yyyy-MM-dd') }}</option>
          </select>
        </clr-select-container>
        <br>
        <button type="button" class="btn btn-secondary" (click)="onViewReport()"
          [clrLoading]="generatingExportReport">Generate report</button>

        <div class="trustees-list">
          <div class="clr-row trustees-info-row">
            <div class="clr-col-3">
              <table *ngIf="exportInfo" class="table table-vertical exportInfo-table">
                <caption>
                  Export status report
                </caption>
                <tbody>
                  <tr>
                    <th class="left">Timestamp</th>
                    <td class="left">{{formatByString(exportInfo.timestamp, 'yyyy-MM-dd HH:mm:ss')}}</td>
                  </tr>
                  <tr>
                    <th class="left">Signed</th>
                    <td class="left">{{exportInfo.data.signedCount}} / {{exportInfo.data.totalCount}}</td>
                  </tr>
                  <tr>
                    <th class="left">Invoiced</th>
                    <td class="left">{{exportInfo.data.invoicedCount}} / {{exportInfo.data.totalCount}}</td>
                  </tr>
                  <tr>
                    <th class="left">Error meters</th>
                    <td class="left">{{exportInfo.data.meterErrorCount}} / {{exportInfo.data.meterTotalCount}}
                      <clr-signpost>
                        <clr-signpost-content [clrPosition]="'right-middle'" *clrIfOpen>
                          <table *ngIf="exportInfo && exportStatusShowDetailed" class="table table-vertical  exportInfo-table">
                            <tbody>
                              <tr>
                                <th class="left">Missing start</th>
                                <td class="left">{{exportInfo.data.meterMissingStartValueCount}}</td>
                              </tr>
                              <tr>
                                <th class="left">Missing end</th>
                                <td class="left">{{exportInfo.data.meterMissingEndValueCount}}</td>
                              </tr>
                              <tr>
                                <th class="left">Zero consumption</th>
                                <td class="left">{{exportInfo.data.meterZeroConsumptionCount}}</td>
                              </tr>
                              <tr>
                                <th class="left">Low consumption</th>
                                <td class="left">{{exportInfo.data.meterLowConsumptionCount}}</td>
                              </tr>
                              <tr>
                                <th class="left">High consumption</th>
                                <td class="left">{{exportInfo.data.meterHighConsumptionCount}}</td>
                              </tr>
                              <tr>
                                <th class="left">Ex. high consumption</th>
                                <td class="left">{{exportInfo.data.meterExceedinglyHighCount}}</td>
                              </tr>
                              <tr>
                                <th class="left">Neg. consumption</th>
                                <td class="left">{{exportInfo.data.meterNegativeConsumptionCount}}</td>
                              </tr>
                              <tr>
                                <th class="left">Missing tariff</th>
                                <td class="left">{{exportInfo.data.meterMissingTariffCount}}</td>
                              </tr>
                              <tr>
                                <th class="left">Missing prev. end</th>
                                <td class="left">{{exportInfo.data.meterMissingPrevEndCount}}</td>
                              </tr>
                              <tr>
                                <th class="left">Has comment</th>
                                <td class="left">{{exportInfo.data.meterHasCommentCount}}</td>
                              </tr>
                            </tbody>
                          </table>
                          <div class="error-export">
                            <button *ngIf="exportInfo" type="button" class="btn btn-secondary"
                                (click)="exportErrorsReport(true)">
                                <cds-icon shape="export"></cds-icon> Export</button>
                          </div>
                        </clr-signpost-content>
                      </clr-signpost>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="clr-col-5 filter-container">
              <clr-toggle-container *ngIf="exportInfo" clrInline>
                <clr-toggle-wrapper>
                  <input type="checkbox" clrToggle [(ngModel)]="filterShowOnlyNotInvoiced" name="showonlynotinvoiced" />
                  <label>Hide invoiced</label>
                </clr-toggle-wrapper>
                <clr-toggle-wrapper>
                  <input type="checkbox" clrToggle [(ngModel)]="filterShowOnlyNotSigned" name="showonlynotsigned" />
                  <label>Hide signed</label>
                </clr-toggle-wrapper>
                <clr-toggle-wrapper>
                  <input type="checkbox" clrToggle [(ngModel)]="filterShowInvoicedActive" name="showinvoicedactive" />
                  <label>Hide inactive</label>
                </clr-toggle-wrapper>
                <clr-toggle-wrapper>
                  <input type="checkbox" clrToggle [(ngModel)]="filterExcludeAfter15" name="excludeafter15" />
                  <label>Exclude tariff</label>
                </clr-toggle-wrapper>
              </clr-toggle-container>
            </div>
            <div class="clr-col-4 export-container">
              <button *ngIf="exportInfo" type="button" class="btn btn-secondary"
                (click)="exportReport(false)">
                <cds-icon shape="export"></cds-icon> Export</button>
              <button *ngIf="exportInfo" type="button" class="btn btn-secondary"
                (click)="exportReport(true)">
                <cds-icon shape="export"></cds-icon> Export not invoiced</button>
            </div>
          </div>

          <clr-datagrid #trusteesgrid *ngIf="exportInfo">
            <clr-dg-column [clrDgField]="'name'" [style.min-width.px]="300">
              <ng-container>Trustee</ng-container>
            </clr-dg-column>
            <clr-dg-column [style.max-width.px]="50">
              <ng-container>Signed</ng-container>
            </clr-dg-column>
            <clr-dg-column [style.max-width.px]="50">
              <ng-container>Invoiced</ng-container>
            </clr-dg-column>
            <clr-dg-column [clrDgField]="'invoiceSchedule'" [style.min-width.px]="250">
              <ng-container>Schedule Day</ng-container>
            </clr-dg-column>
            <clr-dg-column [clrDgField]="'invoiceUser'" [style.min-width.px]="175">
              <ng-container>User</ng-container>
            </clr-dg-column>
            <clr-dg-column [clrDgField]="'invoiceInfo'" [style.min-width.px]="250">
              <ng-container>Invoice info</ng-container>
            </clr-dg-column>
            <clr-dg-column [clrDgField]="'invoiceReportDay'">
              <ng-container>System Report Day </ng-container>
            </clr-dg-column>
            <clr-dg-column [clrDgField]="'invoiceReportEnabled'">
              <ng-container>System Report Enabled</ng-container>
            </clr-dg-column>

            <clr-dg-row
              *clrDgItems="let trusteeInfo of exportInfo.data.trustees | bmsexportinfotrusteepipe : filterShowOnlyNotInvoiced : !filterShowInvoicedActive : filterShowOnlyNotSigned : filterExcludeAfter15;"
              [clrDgItem]="trusteeInfo">
              <clr-dg-cell> {{trusteeInfo.name}}
              </clr-dg-cell>
              <clr-dg-cell [style.max-width.px]="50"> {{trusteeInfo.signedCount}} / {{trusteeInfo.totalCount}}
              </clr-dg-cell>
              <clr-dg-cell [style.max-width.px]="50"> {{trusteeInfo.invoicedCount}} / {{trusteeInfo.totalCount}}
              </clr-dg-cell>
              <clr-dg-cell *ngIf="trusteeInfo !=editTrusteeScheduleInfo" class="edit-mode"
                (dblclick)="editTrusteeSchedule(trusteeInfo)">
                {{trusteeInfo.invoiceSchedule}}
              </clr-dg-cell>
              <clr-dg-cell *ngIf="trusteeInfo == editTrusteeScheduleInfo">
                <div class="edit-container">
                  <div class="icons-edit-wrapper">
                    <label class="edit-label">
                      <clr-textarea-container class="edit-input">
                        <textarea clrTextarea class="edit-input" name="edittrusteeschedule" [rows]="2" [cols]="30"
                          [(ngModel)]="editTrusteeScheduleText"></textarea>
                      </clr-textarea-container>

                      <cds-icon shape="times" size="md" class="edit-mode"
                        (click)="cancelEditTrusteeSchedule()"></cds-icon>
                      <cds-icon shape="check" size="md" class="edit-mode" (click)="saveTrusteeSchedule()"></cds-icon>
                    </label>
                  </div>
                </div>
              </clr-dg-cell>
              <clr-dg-cell *ngIf="trusteeInfo !=editTrusteeUserInfo" class="edit-mode"
                (dblclick)="editTrusteeUser(trusteeInfo)"> {{trusteeInfo.invoiceUser}}
              </clr-dg-cell>
              <clr-dg-cell *ngIf="trusteeInfo == editTrusteeUserInfo">
                <div class="edit-container">
                  <div class="icons-edit-wrapper">
                    <label class="edit-label">
                      <clr-input-container class="edit-input">
                        <input clrInput placeholder="" class="edit-input" max="31" size="17" name="edittrusteeuser"
                          type="text" [(ngModel)]="editTrusteeUserText" />
                      </clr-input-container>
                      <cds-icon shape="times" size="md" class="edit-mode" (click)="cancelEditTrusteeUser()"></cds-icon>
                      <cds-icon shape="check" size="md" class="edit-mode" (click)="saveTrusteeUser()"></cds-icon>
                    </label>
                  </div>
                </div>
              </clr-dg-cell>
              <clr-dg-cell *ngIf="trusteeInfo !=editTrusteeInvoiceInfo" class="edit-mode"
                (dblclick)="editTrusteeInfo(trusteeInfo)">
                {{trusteeInfo.invoiceInfo}}
              </clr-dg-cell>
              <clr-dg-cell *ngIf="trusteeInfo == editTrusteeInvoiceInfo">
                <div class="edit-container">
                  <div class="icons-edit-wrapper">
                    <label class="edit-label">
                      <clr-textarea-container class="edit-input">
                        <textarea clrTextarea class="edit-input" name="edittrusteeinvoiceinfo" [rows]="2" [cols]="30"
                          [(ngModel)]="editTrusteeInvoiceInfoText"></textarea>
                      </clr-textarea-container>

                      <cds-icon shape="times" size="md" class="edit-mode" (click)="cancelEditTrusteeInfo()"></cds-icon>
                      <cds-icon shape="check" size="md" class="edit-mode" (click)="saveTrusteeInfo()"></cds-icon>
                    </label>
                  </div>
                </div>
              </clr-dg-cell>
              <clr-dg-cell *ngIf="trusteeInfo != editTrusteeReportDayInfo" class="edit-mode"
                (dblclick)="editTrusteeReportDay(trusteeInfo)">
                {{trusteeInfo.invoiceReportDay > 0 ? trusteeInfo.invoiceReportDay : ''}}</clr-dg-cell>
              <clr-dg-cell *ngIf="trusteeInfo == editTrusteeReportDayInfo">
                <div class="edit-container">
                  <div class="icons-edit-wrapper">
                    <label class="edit-label">
                      <clr-input-container class="edit-input">
                        <input clrInput placeholder="" class="edit-input" min="0" max="99999999"
                          name="edittrusteereportday" type="number" [(ngModel)]="editTrusteeReportDayNumber" />
                      </clr-input-container>
                      <cds-icon shape="times" size="md" class="edit-mode"
                        (click)="cancelEditTrusteeReportDay()"></cds-icon>
                      <cds-icon shape="check" size="md" class="edit-mode" (click)="saveTrusteeReportDay()"></cds-icon>
                    </label>
                  </div>
                </div>
              </clr-dg-cell>
              <clr-dg-cell>
                <clr-toggle-container class="edit-report-enabled">
                  <clr-toggle-wrapper>
                    <input type="checkbox" clrToggle [(ngModel)]="trusteeInfo.invoiceReportEnabled"
                      name="edittrusteereportenabled_{{trusteeInfo.customerId}}"
                      (change)="saveTrusteeReportEnabled(trusteeInfo)" />
                  </clr-toggle-wrapper>
                </clr-toggle-container>
              </clr-dg-cell>

              <clr-dg-row-detail *clrIfExpanded>
                <clr-datagrid class="customerInfoTable" *ngIf="trusteeInfo.customers">
                  <clr-dg-column [style.min-width.px]="250">
                    <ng-container>Customer</ng-container>
                  </clr-dg-column>
                  <clr-dg-column [style.max-width.px]="115">
                    <ng-container>Association Id</ng-container>
                  </clr-dg-column>
                  <clr-dg-column>
                    <ng-container>ContractType</ng-container>
                  </clr-dg-column>
                  <clr-dg-column>
                    <ng-container>Signed</ng-container>
                  </clr-dg-column>
                  <clr-dg-column>
                    <ng-container>Invoiced</ng-container>
                  </clr-dg-column>
                  <clr-dg-column>
                    <ng-container>Count</ng-container>
                  </clr-dg-column>
                  <clr-dg-column>
                    <ng-container>Errors</ng-container>
                  </clr-dg-column>
                  <clr-dg-column>
                    <ng-container>Tariff</ng-container>
                  </clr-dg-column>
                  <clr-dg-column>
                    <ng-container></ng-container>
                  </clr-dg-column>

                  <clr-dg-row
                    *ngFor="let customerInfo of trusteeInfo.customers | bmsexportinfocustomerpipe : filterShowOnlyNotInvoiced : !filterShowInvoicedActive : filterShowOnlyNotSigned : filterExcludeAfter15">
                    <clr-dg-cell [style.min-width.px]="250" class="customer-info-cell"><a
                        [routerLink]="['/bmsadmin/customers/' + customerInfo.customerId]"
                        routerLinkActive="active">{{customerInfo.name}}</a>{{customerInfo.billingEnabled ? '' : '
                      (Invoice not active)'}}
                    </clr-dg-cell>
                    <clr-dg-cell [style.max-width.px]="115" class="customer-info-cell">{{customerInfo.associationId}}
                    </clr-dg-cell>
                    <clr-dg-cell class="customer-info-cell">{{customerInfo.contractType}}
                    </clr-dg-cell>
                    <clr-dg-cell class="customer-info-cell"><clr-icon shape="check"
                        *ngIf="customerInfo.signed"></clr-icon>
                    </clr-dg-cell>
                    <clr-dg-cell class="customer-info-cell"><clr-icon shape="check"
                        *ngIf="customerInfo.invoiced"></clr-icon>
                    </clr-dg-cell>
                    <clr-dg-cell class="customer-info-cell">{{customerInfo.billingEnabled ? customerInfo.meterCount :
                      ''}}
                    </clr-dg-cell>
                    <clr-dg-cell class="customer-info-cell">{{customerInfo.billingEnabled ? customerInfo.meterErrorCount
                      : ''}}
                    </clr-dg-cell>
                    <clr-dg-cell class="customer-info-cell">
                      <td class="center">
                        <cds-icon shape="exclamation-circle" status="danger" size="sm" solid="false"
                          *ngIf="customerInfo.invoiceDay >= 2 && !customerInfo.tariffsSet"></cds-icon>
                        <cds-icon shape="check-circle" status="success" size="sm" solid="true"
                          *ngIf="customerInfo.invoiceDay >= 2 && customerInfo.tariffsSet"></cds-icon>
                          {{(customerInfo.invoiceDay >= 2 ? '(' + customerInfo.invoiceDay + ')' : '')}}
                      </td>
                    </clr-dg-cell>
                    <clr-dg-cell class="customer-info-cell"> <a
                        [routerLink]="['/bmsadmin/trusteeadmin/' + trusteeInfo.customerId + '/' + customerInfo.customerId]"
                        routerLinkActive="active">
                        <clr-icon shape="eye" size="16" [style.cursor]="'pointer'"></clr-icon>
                      </a></clr-dg-cell>

                    <clr-dg-row-detail *clrIfExpanded>
                      <table class="table meterTypeTable">
                        <thead>
                          <tr>
                            <th class="left">MeterType</th>
                            <th class="left">Signed</th>
                            <th class="left">Invoiced</th>
                            <th class="left">Count</th>
                            <th class="left">Errors</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let meterTypeInfo of customerInfo.meterTypeInfos">
                            <td class="left">
                              {{meterTypeInfo.meterType}}
                            </td>
                            <td *ngIf="meterTypeInfo.billingEnabled" class="left">
                              <clr-icon shape="check" *ngIf="meterTypeInfo.signed"></clr-icon>
                            </td>
                            <td *ngIf="!meterTypeInfo.billingEnabled">Invoice not active</td>
                            <td class="left">
                              <clr-icon shape="check" *ngIf="meterTypeInfo.invoiced"></clr-icon>
                            </td>
                            <td class="left">{{meterTypeInfo.billingEnabled ? meterTypeInfo.meterCount : ''}}</td>
                            <td class="left">
                              {{meterTypeInfo.billingEnabled ? meterTypeInfo.meterErrorCount : ''}}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </clr-dg-row-detail>
                  </clr-dg-row>

                </clr-datagrid>
              </clr-dg-row-detail>
            </clr-dg-row>

          </clr-datagrid>
        </div>
      </form>
    </clr-tab-content>
  </clr-tab>
  <clr-tab>
    <button clrTabLink>Export special report</button>
    <ng-template [(clrIfActive)]="specialActive">
      <clr-tab-content>
        <form clrForm>
          <clr-select-container>
            <label>Billing period</label>
            <select clrSelect name="billingperiodsselectspecial" [(ngModel)]="selectedBillingPeriodSpecial"
              (ngModelChange)="selectedBillingPeriodSpecialChange()">
              <option [ngValue]="BmsBillingPeriod.Month"> Month</option>
              <option [ngValue]="BmsBillingPeriod.Quarter"> Quarter</option>
              <option [ngValue]="BmsBillingPeriod.SixMonths"> Six months</option>
            </select>
          </clr-select-container>
          <clr-select-container>
            <label>Export period</label>
            <select clrSelect name="exportperiodsselectspecial" [(ngModel)]="selectedExportPeriodSpecial"
              (ngModelChange)="selectedExportPeriodSpecialChange()">
              <option *ngFor="let period of exportPeriodsSpecial; let i = index" [ngValue]="i">
                {{formatByString(period.start,
                'yyyy-MM-dd') + ' - ' + formatByString(period.end, 'yyyy-MM-dd') }}</option>
            </select>
          </clr-select-container>

          <br>
          <button type="button" class="btn btn-secondary" (click)="onViewSpecialReport()"
            [clrLoading]="generatingExportReport">Generate special report</button>

          <div class="trustees-list-special">
            <div class="clr-row trustees-info-row">
              <div class="clr-col-3">
                <table *ngIf="exportSpecialInfo" class="table table-vertical exportInfo-table">
                  <caption>
                    Export status report
                  </caption>
                  <tbody>
                    <tr>
                      <th class="left">Timestamp</th>
                      <td class="left">{{formatByString(exportSpecialInfo.timestamp, 'yyyy-MM-dd HH:mm:ss')}}</td>
                    </tr>
                    <tr>
                      <th class="left">Signed</th>
                      <td class="left">{{exportSpecialInfo.data.signedCount}} / {{exportSpecialInfo.data.totalCount}}</td>
                    </tr>
                    <tr>
                      <th class="left">Invoiced</th>
                      <td class="left">{{exportSpecialInfo.data.invoicedCount}} / {{exportSpecialInfo.data.totalCount}}
                      </td>
                    </tr>
                    <tr>
                      <th class="left">Error meters</th>
                      <td class="left">{{exportSpecialInfo.data.meterErrorCount}} / {{exportSpecialInfo.data.meterTotalCount}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="clr-col-6 filter-container">
                <clr-toggle-container clrInline *ngIf="exportSpecialInfo">
                  <clr-toggle-wrapper>
                    <input type="checkbox" clrToggle [(ngModel)]="filterShowOnlyNotInvoicedSpecial"
                      name="specialshowonlynotinvoiced" />
                    <label>Hide invoiced</label>
                  </clr-toggle-wrapper>
                  <clr-toggle-wrapper>
                    <input type="checkbox" clrToggle [(ngModel)]="filterShowOnlyNotSignedSpecial"
                      name="specialshowonlynotsigned" />
                    <label>Hide signed</label>
                  </clr-toggle-wrapper>
                  <clr-toggle-wrapper>
                    <input type="checkbox" clrToggle [(ngModel)]="filterShowInvoicedActiveSpecial"
                      name="showinvoicedactivespecial" />
                    <label>Hide inactive</label>
                  </clr-toggle-wrapper>
                  <clr-toggle-wrapper>
                    <input type="checkbox" clrToggle [(ngModel)]="filterSpecialAfter15" name="after15special" />
                    <label>Tariff only</label>
                  </clr-toggle-wrapper>
                </clr-toggle-container>
              </div>
              <div class="clr-col-3 export-container">
                <button *ngIf="exportSpecialInfo" type="button" class="btn btn-secondary"
                  (click)="exportSpecialReport()">
                  <clr-icon shape="export"></clr-icon> Export</button>
              </div>
            </div>

            <clr-datagrid #trusteesgrid class="" *ngIf="exportSpecialInfo">
              <clr-dg-column>
                <ng-container>Trustee</ng-container>
              </clr-dg-column>
              <clr-dg-column>
                <ng-container>Signed</ng-container>
              </clr-dg-column>
              <clr-dg-column>
                <ng-container>Invoiced</ng-container>
              </clr-dg-column>

              <clr-dg-row
                *ngFor="let trusteeInfo of exportSpecialInfo.data.trustees | bmsexportinfotrusteepipe : filterShowOnlyNotInvoicedSpecial : !filterShowInvoicedActiveSpecial : filterShowOnlyNotSignedSpecial : false : filterSpecialAfter15;">
                <clr-dg-cell> {{trusteeInfo.name}}
                </clr-dg-cell>
                <clr-dg-cell> {{trusteeInfo.signedCount}} / {{trusteeInfo.totalCount}}
                </clr-dg-cell>
                <clr-dg-cell> {{trusteeInfo.invoicedCount}} / {{trusteeInfo.totalCount}}
                </clr-dg-cell>

                <clr-dg-row-detail *clrIfExpanded>
                  <table class="table customerInfoTable-special">
                    <caption>
                      Customers status
                    </caption>
                    <thead>
                      <tr>
                        <th class="left">Customer</th>
                        <th class="left">Association Id</th>
                        <th class="left">ContractType</th>
                        <th class="left">Signed</th>
                        <th class="left">Invoiced</th>
                        <th class="left">Count</th>
                        <th class="left">Errors</th>
                        <th class="left">Tariff</th>
                        <th class="left">Special</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="let customerInfo of trusteeInfo.customers | bmsexportinfocustomerpipe : filterShowOnlyNotInvoicedSpecial : !filterShowInvoicedActiveSpecial : filterShowOnlyNotSignedSpecial : false : filterSpecialAfter15">
                        <td class="left"><a [routerLink]="['/bmsadmin/customers/' + customerInfo.customerId]"
                            routerLinkActive="active">{{customerInfo.name}}</a>
                          {{customerInfo.billingEnabled ? '' : ' (Invoice not active)'}}</td>
                        <td class="left">{{customerInfo.associationId}}</td>
                        <td class="left">{{customerInfo.contractType}}</td>
                        <td class="left">
                          <clr-icon shape="check" *ngIf="customerInfo.signed"></clr-icon>
                        </td>
                        <td class="left">
                          <clr-icon shape="check" *ngIf="customerInfo.invoiced"></clr-icon>
                        </td>
                        <td class="left">{{customerInfo.billingEnabled ? customerInfo.meterCount : ''}}</td>
                        <td class="left">{{customerInfo.billingEnabled ? customerInfo.meterErrorCount : ''}}</td>
                        <td class="center">
                          <cds-icon shape="exclamation-circle" status="danger" size="sm" solid="false"
                            *ngIf="customerInfo.invoiceDay >= 2 && !customerInfo.tariffsSet"></cds-icon>
                          <cds-icon shape="check-circle" status="success" size="sm" solid="true"
                            *ngIf="customerInfo.invoiceDay >= 2 && customerInfo.tariffsSet"></cds-icon>
                            {{(customerInfo.invoiceDay >= 2 ? '(' + customerInfo.invoiceDay + ')' : '')}}
                        </td>
                        <td class="left invoice-specail-col" *ngIf="customerInfo.invoiceInfo?.length > 0">
                          <cds-icon shape="bubble-exclamation" status="warning" size="sm"></cds-icon>
                          {{customerInfo.invoiceInfo}}
                        </td>
                        <td *ngIf="!customerInfo.invoiceInfo || customerInfo.invoiceInfo.length == 0"></td>
                        <td class="left">
                          <a [routerLink]="['/bmsadmin/trusteeadmin/' + trusteeInfo.customerId + '/' + customerInfo.customerId]"
                            routerLinkActive="active">
                            <clr-icon shape="eye" size="16" [style.cursor]="'pointer'"></clr-icon>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </clr-dg-row-detail>
              </clr-dg-row>
            </clr-datagrid>
          </div>
        </form>
      </clr-tab-content>
    </ng-template>
  </clr-tab>
  <clr-tab>
    <button clrTabLink>Trustees report</button>
    <clr-tab-content>
      <ng-template [(clrIfActive)]="trusteeCustomerActive">
        <div class="trustee-report-area">
          <app-dashboard #dashboardTrusteeCustomers [editMode]="false" [showDashboardSettings]="false"
            [dashboardId]="'bms_trustee_customers'" [enableExport]="true"></app-dashboard>
        </div>
      </ng-template>
    </clr-tab-content>
  </clr-tab>
</clr-tabs>
